import { render, staticRenderFns } from "./VehicleStateList.vue?vue&type=template&id=53bd3ab0"
import script from "./VehicleStateList.vue?vue&type=script&lang=js"
export * from "./VehicleStateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports